import { render, staticRenderFns } from "./Administrator.vue?vue&type=template&id=201287d2"
import script from "./Administrator.vue?vue&type=script&lang=js"
export * from "./Administrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports